<template>
  <VacancyForm
    :user="user"
    :company="company"
    :vacancy="vacancy"
  >
    <template v-slot:buttons="{ submit }">
      <VBtn
        color="success"
        dark
        :loading="loading"
        elevation="0"
        @click="next(submit)"
      >
        {{ $t('save') }}
      </VBtn>
      <VBtn
        color="success"
        outlined
        dark
        class="ml-3"
        @click="cancel"
      >
        {{ $t('cancel') }}
      </VBtn>
    </template>
  </VacancyForm>
</template>

<script>
import Company from '@/orm/models/Company/Company';
import ValidationMixin from '../../mixins/ValidationMixin';
import VacancyForm from './VacancyForm.vue';

export default {
  name: 'VacancyEdit',
  metaInfo() {
    return {
      title: this.$t('vacancyEditing'),
    };
  },
  components: { VacancyForm },
  mixins: [ValidationMixin],
  props: {
    user: {
      type: Object,
      required: true,
    },
    vacancy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    company() {
      return Company.query().withAllRecursive().first();
    },
  },
  methods: {
    async next(submit) {
      await this.withLoading(async () => {
        const vacancy = await submit();
        if (vacancy !== null) {
          await this.$router.push({ name: 'vacancy', params: { id: this.vacancy.id } });
        }
      });
    },
    cancel() {
      this.$router.push({ name: 'vacancy', params: { id: this.vacancy.id } });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  save: Save
  cancel: Cancel
  vacancyEditing: Edit job
</i18n>

<i18n locale="ru" lang="yaml">
  save: Сохранить
  cancel: Отменить
  vacancyEditing: Редактировать вакансию
</i18n>
